/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Alert } from 'sarsaparilla';

export type SetPasswordFormErrorType = 'unknown' | null;

interface SetPasswordFormErrorsProps {
    errorType: SetPasswordFormErrorType;
    className?: string;
}

export function SetPasswordFormErrors({
    errorType,
    className,
}: SetPasswordFormErrorsProps) {
    if (!errorType) {
        return null;
    }

    return (
        <Alert
            type="error"
            heading="Password Save Failed"
            shouldFocusOnMount
            className={className}
        >
            Something went wrong while trying to save your password. Please try again in a
            moment. If the problem persists, try refreshing the page.
        </Alert>
    );
}
